import { Location, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  TemplateRef,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { BaseDialog } from '../dialog/base-dialog';
import { BASE_DIALOG_IMPORTS } from '../dialog/dialog-imports';

export interface ReferencedDialogReference {
  label: string;
  hint: string;
  draftId: string | null;
}

export interface ReferencedDialogData {
  title: string;
  message: string;
  path: string;
  references: ReferencedDialogReference[];
}

@Component({
  selector: 'app-referenced-dialog',
  imports: [BASE_DIALOG_IMPORTS, MatIcon, MatIconButton, MatTooltip, NgTemplateOutlet],
  templateUrl: './referenced-dialog.component.html',
  styleUrl: './referenced-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferencedDialogComponent extends BaseDialog<ReferencedDialogData> {
  private readonly _dialogRef =
    inject<MatDialogRef<ReferencedDialogComponent>>(MatDialogRef);
  private readonly _router = inject(Router);
  private readonly _location = inject(Location);

  readonly footerTemplate = input<TemplateRef<unknown>>();

  override handleConfirm(): void {
    this._dialogRef.close(null);
  }

  navigateTo(draftId: string): void {
    const url = this._location.prepareExternalUrl(
      this._router.serializeUrl(this._router.createUrlTree([this.data.path, draftId]))
    );
    window.open(url, draftId);
  }
}
